/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DatabaseColumnLayout
 */
export interface DatabaseColumnLayout {
    /**
     * 
     * @type {number}
     * @memberof DatabaseColumnLayout
     */
    desktop?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseColumnLayout
     */
    tablet?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseColumnLayout
     */
    mobile?: number;
}

/**
 * Check if a given object implements the DatabaseColumnLayout interface.
 */
export function instanceOfDatabaseColumnLayout(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseColumnLayoutFromJSON(json: any): DatabaseColumnLayout {
    return DatabaseColumnLayoutFromJSONTyped(json, false);
}

export function DatabaseColumnLayoutFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseColumnLayout {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'desktop': !exists(json, 'desktop') ? undefined : json['desktop'],
        'tablet': !exists(json, 'tablet') ? undefined : json['tablet'],
        'mobile': !exists(json, 'mobile') ? undefined : json['mobile'],
    };
}

export function DatabaseColumnLayoutToJSON(value?: DatabaseColumnLayout | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'desktop': value.desktop,
        'tablet': value.tablet,
        'mobile': value.mobile,
    };
}

